import { Session } from "../index.js";

// Initialization object
async function endGame(sessionId: string) {
	var session = Session.get(sessionId);
	if (!session) return;
	// Drain the cleanup list so a second teardown (server game:end followed by
	// component unmount) can't re-run cleanup functions.
	const cleanups = (session.cleanup as Array<() => void>).splice(0);
	cleanups.forEach((fx) => fx());

	var mountPoint = session.mountPoint as string;
	const mountElement = document.getElementById(mountPoint);
	if (mountElement) {
		mountElement.innerHTML = "";
		mountElement.style.display = "none";
	}
	var rootPoint = session.rootPoint as string;
	const rootElement = document.getElementById(rootPoint);
	if (rootElement) rootElement.style.display = "block";
	if (typeof session.onEnd === "function") (session.onEnd as () => void)();
}

export default endGame;
